export default __webpack_public_path__ + "static/media/download-app.b6102e8a.png";